(function() {

  'use strict';

  /**
   * Bundle Component
   * @type BundleCmpCtrl
   * @name BundleCtrl
   */
  var productSizesSelectCmp = {
      bindings: {
        checked: '<',
        sizes: '<',
        selected: '<',
        showError: '<',
        onSelected: '&'
      },
      controller: productSizesSelectCmpCtrl,
      templateUrl: 'product-sizes-select.component.html'
  };

  angular.module('itxApp.common')
      .component('productSizesSelect', productSizesSelectCmp);

  productSizesSelectCmpCtrl.$inject = [
    'ItxSizeGuideSvc'
  ];

  function productSizesSelectCmpCtrl( ItxSizeGuideSvc ) {
      var _this = this;
      
      var HIDDEN = joyr.constants.visibility.HIDDEN_VISIBILITY;
      var DISABLED = joyr.constants.visibility.DISABLED_VISIBILITY;
      var SOLD_OUT = joyr.constants.visibility.SOLD_OUT_VISIBILITY;

      _this.$onInit = function(){
        _this.sizes = ItxSizeGuideSvc.removeDuplicates( _this.sizes );
        _this.checkSizes();
      }

      _this.$onChanges = function(){
        _this.checkSizes();
        _this.sizes = ItxSizeGuideSvc.removeDuplicates( _this.sizes );
      };

      _this.checkSizes = function () {
        _this.sizes = _.filter(_this.sizes, function (s) {
          if (s.visibility === HIDDEN || s.visibility === DISABLED || s.visibility === SOLD_OUT) {
            return false;
          } else {
            return true;
          }
        });

        _this.uniqueSize =  (_this.sizes.length === 1 && _this.sizes[0].name === '01');
      };

      _this.hasChanged = function() {
        _this.onSelected({size: _this.selected});
      };

  }

})();
